import React from 'react'
import "./css/loader.css"

export  function Loader() {
  return (
    <div className="dots-loader">
    <span className="dot"></span>
    <span className="dot"></span>
    <span className="dot"></span>
    <span className="dot"></span>
  </div>
  )
}
